import {
  RollbarConfiguration,
  RollbarConfigurationPayload
} from '../../utils/globalWindow';
import { CurrentUserInfo } from './interface';

export const postSignInUtilities = (userInfo: CurrentUserInfo): void => {
  // fullstory
  if (window.FS && userInfo.username && userInfo.attributes?.email) {
    window.FS.identify(userInfo.username, {
      email: userInfo.attributes.email
    });
  }

  // rollbar
  if (window.Rollbar) {
    const rollbarConfig: RollbarConfiguration = {
      payload: {},
      onSendCallback: (
        isUncaught: boolean,
        args: unknown,
        payload: RollbarConfigurationPayload
      ) => {
        if (window.FS && window._fs_loaded) {
          payload.fullstoryURL = window.FS.getCurrentSessionURL(true);
        }
      }
    };

    if (userInfo.username && userInfo.attributes?.email) {
      rollbarConfig.payload.person = {
        id: userInfo.username,
        email: userInfo.attributes.email
      };
    }
    window.Rollbar.configure(rollbarConfig);
  }

  // Intercom
  if (userInfo.attributes?.email && window.Intercom) {
    window.Intercom('boot', {
      api_base: 'https://api-iam.intercom.io',
      app_id: 'kr1yky2b',
      email: userInfo.attributes.email // the email for your user
      // created_at: userInfo.attributes?.c, // Signup date as a Unix timestamp
    });
  }
};
